import { Action } from '../Card';
import React, { useContext, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { PagesQuery } from '../../generated/graphql';
import { newItemsRoute } from '../../helpers/routes';
import { TrackingContext } from '../../TrackingContext';
import styles from './addToPageButton.scss';
export type Page = PagesQuery['pages'][0];

interface Props {
  page: Page;
  preview?: boolean;
}

const AddToPageButton: React.FC<Props> = ({ page, preview }) => {
  const history = useHistory();
  const { track } = useContext(TrackingContext);

  let addMoreToCopy = useMemo(
    () => (page.type === 'TravelPage' ? 'Add hotels and more manually' : `Add More to ${page.title}`),
    [page]
  );

  return (
    <Action
      iconName="add_circle"
      onClick={() => {
        history.push(newItemsRoute(page.id, preview));
        track('Item Action Initiated', {
          action: 'add',
          actionName: `Add to ${page.title}`,
          page: page.title,
          item: null,
        });
      }}
      className={styles.addToPageButton}
      data-testid={`add-more-to-${page.id}`}
    >
      {addMoreToCopy}
    </Action>
  );
};

export default AddToPageButton;
